// CANONICAL COPY (GH #7115). src/constants/obligations/obl-ski-privacy-breach-handling.js re-exports this file so the browser and the
// Function App share one compliance engine — one definition of "compliant". Edit here, never there.
'use strict';

module.exports = {
  id: 'obl-ski-privacy-breach-handling',
  title: 'Maintain a method for handling personal data breaches including authority notification',
  description:
    'The organisation must have a documented method for handling breaches of personal data privacy that includes: identifying when and how the breach occurred; a process for managing and containing the breach; and procedures for notifying relevant supervisory authorities and data subjects as required by applicable law (GDPR).',
  category: 'compliance',
  scfIds: ['SCF-PRV-004', 'SCF-INC-001'],
  cadence: { frequency: '1y', anchor: 'domain' },
  strategy: 'all',
  fulfilmentCriteria: [
    { type: 'document-published', description: 'Privacy breach handling procedure is published' },
    { type: 'document-approved', description: 'Procedure has been approved' },
    { type: 'document-within-sla', description: 'Procedure review is not overdue' },
  ],
  domainActions: [{ type: 'approve-document', label: 'Approve Document' }],
};
